import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningIcon from "@mui/icons-material/Warning";
import Grid from "@mui/material/Grid";
import React from "react";
import Draggable from "react-draggable";
import { Paper, PaperClasses, PaperProps, SxProps, Theme } from "@mui/material";
import { CommonProps } from "@mui/material/OverridableComponent";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#alert-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

interface ErrorModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  description: string;
  children: React.ReactNode;
  confirmText?: string;
}

const ErrorModal = ({
  show,
  handleClose,
  title,
  description,
  children,
  confirmText = "Close",
  ...rest
}: ErrorModalProps) => {
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-label={title}
      aria-labelledby="alert-dialog-title"
      aria-describedby={description}
      PaperComponent={PaperComponent}
      tabIndex={-1}
      {...rest}
    >
      <DialogTitle style={{ cursor: "move" }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
       
          <Grid container spacing={0}>
            <Grid item xs={2}>
              <WarningIcon sx={{ fontSize: 60 }} color="error"></WarningIcon>
            </Grid>
            <Grid item xs={10}>
            <DialogContentText id="alert-dialog-description">
              {children}
              </DialogContentText>
            </Grid>
          </Grid>
       
      </DialogContent>
      <DialogActions>
      <button
          type="button"
          className="btn btn-primary k-mr-2"
          onClick={() => {
            handleClose();
          }}
        >
          {confirmText}
        </button>        
        
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
